import { Modal } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import Lottie from "lottie-react";
import animationData from "../../../components/wizard/lottie/warning-light.json";
import { GetAllClaimsList } from "../config/cliamApi";
import { useDispatch } from "react-redux";

const ErrorMultiplecancelModal = ({
  show,
  onClose,
  error,
  setPage,
  setRowsPerPage,
  body,
}) => {
  const dispatch = useDispatch();

  const successCount = Object.values(error || {}).filter(
    (claim) => claim?.status === "completed"
  ).length;

  const failedClaims = Object.values(error || {}).filter(
    (claim) => claim?.status === "failed"
  );

  const title =
    failedClaims.length > 0
      ? "Unable to Cancel All Claims"
      : "All Claims Cancelled Successfully";

  const description = (
    <div>
      {successCount > 0 && (
        <div className="mb-2 text-success fs-9">
          <strong>Successfully Cancelled Claims:</strong> {successCount}
        </div>
      )}
      {failedClaims.length > 0 && (
        <div className="text-danger fs-10">
          <strong>Failed Claims:</strong>
          {failedClaims.map((claim, index) => (
            <div key={index} className="mb-1">
              ({claim?.claim_id}) -{" "}
              {claim?.error_code ? `[${claim?.error_code}] - ` : ""}
              {claim?.error_msg || "Unknown error"}
            </div>
          ))}
        </div>
      )}
    </div>
  );

  const handleClose = async () => {
    onClose();
    setPage(0);
    setRowsPerPage(10);
    await dispatch(GetAllClaimsList(body)).unwrap();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center px-4">
        <FalconCloseButton
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
          onClick={handleClose}
        />

        <Lottie
          animationData={animationData}
          loop
          style={{ width: 120, height: 120, margin: "0 auto" }}
        />

        <h5 className="mt-3 text-danger fw-bold">{title}</h5>
        <div className="text-muted fs-10 mt-2">{description}</div>
      </Modal.Body>
    </Modal>
  );
};

export default ErrorMultiplecancelModal;
